module.exports = __webpack_public_path__ + "img/primary_9x1.a5204b21.svg";